import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPeriodo } from '../dto/periodo.dto';

@Injectable({
  providedIn: 'root'
})
export class PeriodoService {

  private urlEndPoint = environment.urlEndPoint.concat('/autenticado/periodo');

  constructor(private httpClient: HttpClient) { }

  public obtenerPorPeriodoInicioEstudiante(cerDependencia: string): Observable<IPeriodo[]>{
    return this.httpClient.get<IPeriodo[]>(`${this.urlEndPoint}/obtener-por-periodo-inicio-estudiante`, { params: { cerDependencia } });
  }
}
